// import Vue from 'vue'
// import Router from 'vue-router'
import zhifu from '@/pages/zhifu'
import alipayzhifu from '@/pages/alipayzhifu'
import YunFeiList from '@/pages/YunFList'
import zhifubaozf from '@/pages/zhifubaozf'
import chongzhizhifu from '@/pages/chongzhizhifu'
import store from "../store"
import { Message } from 'element-ui'
import VueCookies from 'vue-cookies'

var router = new VueRouter({
  mode:'history',
  // base:'/dist',
  routes: [
    {
      path: '*',
      redirect:'/',
      component: resolve => require(['../pages/HelloWorld'], resolve),
      meta:{
        title: '首页',
        keepAlive: false
      }
    },
    {
      path: '/',
      name: 'HelloWorld',
      component: resolve => require(['../pages/HelloWorld'], resolve),
      meta: {
        title: '首页',
        keepAlive: false
      }
    },
    {
      path: '/test',
      name: 'test',
      component: resolve => require(['../pages/test'], resolve),
      meta: {
        title: '测试'
      }
    },
    {
      path: '/relet',
      name: 'relet',
      component: resolve => require(['../pages/relet'], resolve),
      meta: {
        title: '续租'
      }
    },
    {
      path: '/download',
      name: 'download',
      component: resolve => require(['../pages/download'], resolve),
      meta: {
        title: '下载'
      }
    },
    {
      path: '/rentalAgreement',
      name: 'rentalAgreement',
      component: resolve => require(['../pages/rentalAgreement'], resolve),
      meta: {
        title: '租赁协议'
      }
    },
    {
      path: '/payment',
      name: 'payment',
      component: resolve => require(['../pages/payment'], resolve),
      meta: {
        title: '结算页面'
      }
    },
    {
      path: '/UserLogin',
      name: 'UserLogin',
      component: resolve => require(['../pages/UserLogin'], resolve),
      meta: {
        title: '用户登录'
      }
    },
    {
      path: '/forgetpwd',
      name: 'ForgetPwd',
      component: resolve => require(['../pages/ForgetPwd'], resolve),
      meta: {
        title: '忘记密码'
      }
    },
    {
      path: '/BusinessUser',
      name: 'BusinessUser',
      component: resolve => require(['../pages/BusinessUser'], resolve),
      meta: {
        title: '商家登录'
      }
    },
    {
      path: '/askAnswer1',
      name: 'askAnswer1',
      component: resolve => require(['../pages/askAnswer1'], resolve),
      meta: {
        title: '租赁问答',
        keepAlive: true
      }
    },
    {
      path: '/YunFeiList',
      name: 'YunFeiList',
      component: YunFeiList,
      meta: {
        title: '运费列表'
      }
    },
    {
      path: '/GoodsList',
      name: 'GoodsList',
      component: resolve => require(['../pages/GoodsList'], resolve),
      meta: {
        title: '商品列表'
      }
    },
    {
      path: '/GoodsDetail',
      name: 'GoodsDetail',
      component: resolve => require(['../pages/GoodsDetail'], resolve),
      meta: {
        title: '商品详情'
      }
    }, {
      path: '/SupplierDetail',
      name: 'SupplierDetail',
      component: resolve => require(['../pages/SupplierDetail'], resolve),
      meta: {
        title: '店铺详情'
      }
    },
    {
      path: '/Balance',
      name: 'Balance',
      component: resolve => require(['../pages/Balance'], resolve),
      meta: {
        title: '提交订单'
      }
    },
    {
      path: '/news',
      name: 'news',
      component: resolve => require(['../pages/news'], resolve),
      meta: {
        title: '媒体报道'
      }
    },
    {
      path: '/alipayzhifu',
      name: 'alipayzhifu',
      component: alipayzhifu,
      meta: {
        title: '支付宝支付'
      }
    },
    {
      path: '/zhifu',
      name: 'zhifu',
      component: zhifu,
      meta: {
        title: '微信支付'
      }
    },
    {
      path: '/zhifubaozf',
      name: 'zhifubaozf',
      component: zhifubaozf,
      meta: {
        title: '支付宝支付'
      }
    },
    {
      path: '/chongzhizhifu',
      name: 'chongzhizhifu',
      component: chongzhizhifu,
      meta: {
        title: '充值支付'
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: resolve => require(['../pages/privacy'], resolve),
      meta: {
        title: '隐私政策',
        keepAlive: true
      }
    },
    {
      path: '/invite',
      name: 'invite',
      component: resolve => require(['../pages/invite'], resolve),
      meta: {
        title: 'h5邀请好友注册',
        isApp: true
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: resolve => require(['../pages/userAgreement'], resolve),
      meta: {
        title: '用户协议',
        keepAlive: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: resolve => require(['../pages/user'], resolve),
      meta: {
        title: '用户',
        keepAlive: true
      },
      redirect: '/my',
      children: [
        {
          path: '/my',
          name: 'newMy',
          component: resolve => require(['../pages/newMy'], resolve),
          meta: {
            title: '个人资料'
          }
        },
        {
          path: '/mywallet',
          name: 'newMyWallet',
          component: resolve => require(['../pages/newMyWallet'], resolve),
          meta: {
            title: '用户钱包'
          }
        },
        {
          path: '/myorder',
          name: 'newMyOrder',
          component: resolve => require(['../pages/newMyOrder'], resolve),
          meta: {
            title: '我的订单'
          }
        },
        {
          path: '/mymessage',
          name: 'newMyMsg',
          component: resolve => require(['../pages/newMyMsg'], resolve),
          meta: {
            title: '我的消息'
          }
        },
        {
          path: '/MyShoucang',
          name: 'newMyFavor',
          component: resolve => require(['../pages/newMyFavor'], resolve),
          meta: {
            title: '我的收藏'
          }
        },
        {
          path: '/newMyCart',
          name: 'newMyCart',
          component: resolve => require(['../pages/newMyCart'], resolve),
          meta: {
            title: '租物车'
          }
        },
        {
          path: '/shouhuoDizhi',
          name: 'newMyAddress',
          component: resolve => require(['../pages/newMyAddress'], resolve),
          meta: {
            title: '收货地址'
          }
        },
        {
          path: '/userCouponList',
          name: 'userCouponList',
          component: resolve => require(['../pages/userCouponList'], resolve),
          meta: {
            title: '优惠券管理'
          }
        },
        {
          path: '/userpassword',
          name: 'newMyPwd',
          component: resolve => require(['../pages/newMyPwd'], resolve),
          meta: {
            title: '用户修改密码'
          }
        },
        {
          path: '/myinvoice',
          name: 'newMyInvoice',
          component: resolve => require(['../pages/newMyInvoice'], resolve),
          meta: {
            title: '发票管理'
          }
        },
      ]
    },
    {
      path: '/newMerchant',
      name: 'newMerchant',
      component: resolve => require(['../pages/newMerchant'], resolve),
      meta: {
        title: '商家',
        keepAlive: true
      },
      redirect: '/SupplierManage',
      children: [
        {
          path: '/SupplierManage',
          name: 'newSupplierManage',
          component: resolve => require(['../pages/newSupplierManage'], resolve),
          meta: {
            title: '店铺管理'
          }
        },
        {
          path: '/Merchant',
          name: 'newSupplierWallet',
          component: resolve => require(['../pages/newSupplierWallet'], resolve),
          meta: {
            title: '商家钱包'
          }
        },
        {
          path: '/GoodsGuanli',
          name: 'newGoodsManage',
          component: resolve => require(['../pages/newGoodsManage'], resolve),
          meta: {
            title: '商品管理'
          }
        },
        {
          path: '/newOrderManage',
          name: 'newOrderManage',
          component: resolve => require(['../pages/newOrderManage'], resolve),
          meta: {
            title: '订单管理'
          }
        },
        {
          path: '/AfterSaleManage',
          name: 'newAfterSaleManage',
          component: resolve => require(['../pages/newAfterSaleManage'], resolve),
          meta: {
            title: '售后管理'
          }
        },
        {
          path: '/Fatherfreight',
          name: 'newFreightModels',
          component: resolve => require(['../pages/newFreightModels'], resolve),
          meta: {
            title: '运费模板'
          }
        },
        {
          path: '/quanxian_password',
          name: 'newSupplierPwd',
          component: resolve => require(['../pages/newSupplierPwd'], resolve),
          meta: {
            title: '商家修改密码'
          }
        },
        {
          path: '/myCard',
          name: 'newSupplierCard',
          component: resolve => require(['../pages/newSupplierCard'], resolve),
          meta: {
            title: '商家银行卡'
          }
        },
        {
          path: '/newSupplierIn',
          name: 'newSupplierIn',
          component: resolve => require(['../pages/newSupplierIn'], resolve),
          meta: {
            title: '收入明细'
          }
        },
      ]
    }
  ]
})

var needUidPath = ['/my', '/mywallet', '/myorder', '/mymessage', '/MyShoucang', '/newMyCart', '/shouhuoDizhi', '/userpassword', '/relet', '/Balance', '/payment'],
  needSupplierIdPath = ['/SupplierManage', '/Merchant', '/GoodsGuanli', '/newOrderManage', '/AfterSaleManage', '/Fatherfreight', '/quanxian_password', '/myCard']
router.beforeEach((to, from, next) => {
  document.title = to.path=='/'?'大租行-影视器材租赁':('大租行-'+to.meta.title);
  if (to.path == '/') {
    router.options.routes[0].meta.keepAlive = VueCookies.get("city_is_changed") == 'true' ? false : true
  }
  if (needSupplierIdPath.indexOf(to.path) != -1) {
    if (!VueCookies.get('supplier_id') || !VueCookies.get('uid') || !VueCookies.get('browser_token')) {
      Message.warning('请先登录')
      VueCookies.set('uid', '')
      VueCookies.set('supplier_id', '')
      VueCookies.set('browser_token', '')
      VueCookies.set('wallet_amount', '')
      store.commit("userOrder/changeCartNum", 0);
      store.dispatch("userOrMerchant/userStatusAction", false);
      store.dispatch("userOrMerchant/merchantStatusAction", false);
      router.replace('/BusinessUser')
    }
  }
  if (needUidPath.indexOf(to.path) != -1) {
    if (!VueCookies.get('uid') || !VueCookies.get('browser_token')) {
      Message.warning('请先登录')
      VueCookies.set('uid', '')
      VueCookies.set('supplier_id', '')
      VueCookies.set('browser_token', '')
      VueCookies.set('wallet_amount', '')
      store.commit("userOrder/changeCartNum", 0);
      store.dispatch("userOrMerchant/userStatusAction", false);
      store.dispatch("userOrMerchant/merchantStatusAction", false);
      router.replace('/UserLogin')
    }
  }
  if (to.path == '/BusinessUser') {
    if (!(!VueCookies.get('supplier_id') || !VueCookies.get('uid') || !VueCookies.get('browser_token'))) {
      router.replace('/')
    }
  }
  if (to.path == '/UserLogin') {
    if (!(!VueCookies.get('uid') || !VueCookies.get('browser_token'))) {
      router.replace('/')
    }
  }
  next()
});
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js